import cn from 'classnames';
import { HTMLAttributes, ReactNode } from 'react';

import styles from './PageSection.module.scss';

interface PageSectionProps extends HTMLAttributes<HTMLElement> {
    children: ReactNode;
    containerClassName?: string;
    fullHeight?: boolean;
}

const PageSection = ({
    children,
    className,
    containerClassName,
    fullHeight = false,
    ...restProps
}: PageSectionProps) => (
    <section {...restProps} className={cn(className, fullHeight && styles.pageSection_fullHeight)}>
        <div
            className={cn(
                styles.pageSection_container,
                fullHeight && styles.pageSection_fullHeight,
                containerClassName
            )}
        >
            {children}
        </div>
    </section>
);

export default PageSection;
